import { useState } from 'react';
import { Link, useLocation } from 'react-router';
import { t } from '../messages/vi';
import { SIGN_IN_PATH, signInHref, useAuth } from '../providers';
import { MainNav } from './app-nav';
import './app-header.css';

/**
 * Top bar of the non-immersive screens, sticky: the logo and app name ("Ôn Lái Xe"), "Điều hướng
 * chính" (from 768px) and the account state, at every width (e2e accounts looks for it in the
 * banner). Signed in: "Lịch sử", the email, "Tài khoản" (`/tai-khoan`: email, account deletion) and
 * "Đăng xuất"; under 768px "Lịch sử" and "Tài khoản" are hidden (both are on /toi, the "Tôi" tab) so
 * the bar stays one row at 320px. Signed out: "Đăng nhập", which comes back to the current page.
 * While the session is still loading the account slot keeps its place, empty, so nothing jumps.
 */
export function AppHeader() {
  const { status, user, signOut } = useAuth();
  const location = useLocation();
  const [signingOut, setSigningOut] = useState(false);
  const [failed, setFailed] = useState(false);

  const onSignOut = async () => {
    setSigningOut(true);
    setFailed(false);
    const ok = await signOut();
    setSigningOut(false);
    setFailed(!ok);
  };

  const here = `${location.pathname}${location.search}${location.hash}`;
  const onSignInPage = location.pathname === SIGN_IN_PATH;

  return (
    <header className="app-header">
      <Link to="/" className="app-header__brand">
        <img className="app-header__logo" src="/icons/icon.svg" alt="" width={28} height={28} />
        {t('header.brand')}
      </Link>
      <MainNav />
      <nav className="app-header__account" aria-label={t('header.account')}>
        {status === 'authenticated' && user ? (
          <>
            <Link to="/lich-su" className="app-header__link">
              {t('header.history')}
            </Link>
            <span className="app-header__email" title={user.email}>
              {user.email}
            </span>
            <Link to="/tai-khoan" className="app-header__link">
              {t('header.accountLink')}
            </Link>
            <button
              type="button"
              className="app-header__button"
              onClick={() => void onSignOut()}
              disabled={signingOut}
            >
              {signingOut ? t('header.signingOut') : t('header.signOut')}
            </button>
          </>
        ) : status === 'anonymous' && !onSignInPage ? (
          <Link to={signInHref(here)} className="app-header__button">
            {t('header.signIn')}
          </Link>
        ) : null}
      </nav>
      {failed ? (
        <p className="app-header__error" role="alert">
          {t('auth.error.signOut')}
        </p>
      ) : null}
    </header>
  );
}
